import React, { useEffect, useState } from "react";
import { api } from "../api";
import { AdminCaseListItem, STATUS_LABELS } from "../types";
import { Spinner, StatusBadge, formatMoney } from "../common/ui";

const STATUS_OPTIONS = ["", ...Object.keys(STATUS_LABELS)];

export function CaseList({ onOpenCase }: { onOpenCase: (id: string) => void }) {
  const [items, setItems] = useState<AdminCaseListItem[]>([]);
  const [total, setTotal] = useState(0);
  const [page, setPage] = useState(1);
  const [search, setSearch] = useState("");
  const [status, setStatus] = useState("");
  const [loading, setLoading] = useState(true);
  const pageSize = 20;

  async function load() {
    setLoading(true);
    try {
      const res = await api.adminListCases({
        page: String(page), pageSize: String(pageSize),
        ...(search ? { search } : {}), ...(status ? { status } : {}),
      });
      setItems(res.items || []);
      setTotal(res.total);
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    load();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page, status]);

  return (
    <div>
      <h2>پرونده‌ها</h2>
      <div className="filters-row">
        <input
          placeholder="جستجو: نام، شناسه زودکس، کد ملی، شماره پرونده..."
          value={search}
          onChange={(e: any) => setSearch(e.target.value)}
          onKeyDown={(e: any) => e.key === "Enter" && (setPage(1), load())}
          style={{ minWidth: 280 }}
        />
        <select value={status} onChange={(e: any) => { setStatus(e.target.value); setPage(1); }}>
          {STATUS_OPTIONS.map((s) => <option key={s} value={s}>{s ? STATUS_LABELS[s] : "همه وضعیت‌ها"}</option>)}
        </select>
        <button className="btn btn-secondary btn-sm" onClick={() => { setPage(1); load(); }}>جستجو</button>
      </div>

      {loading ? <Spinner /> : (
        <div className="table-wrap">
          <table>
            <thead>
              <tr>
                <th>شماره پرونده</th><th>پذیرنده</th><th>شناسه زودکس</th><th>صاحب جواز</th>
                <th>موبایل</th><th>مبلغ درخواستی</th><th>تکمیل</th><th>وضعیت</th><th>مسئول</th><th>ثبت</th>
              </tr>
            </thead>
            <tbody>
              {items.map((c) => (
                <tr key={c.id} className="clickable" onClick={() => onOpenCase(c.id)}>
                  <td style={{ fontFamily: "monospace" }}>{c.caseNumber}</td>
                  <td>{c.storeName}</td>
                  <td>{c.merchantZoodexId}</td>
                  <td>{c.ownerName}</td>
                  <td>{c.merchantMobile}</td>
                  <td>{formatMoney(c.requestedAmount)}</td>
                  <td>{c.completionPercent}٪</td>
                  <td><StatusBadge status={c.status} labels={STATUS_LABELS} /></td>
                  <td>{c.assignedToName || "—"}</td>
                  <td>{new Date(c.createdAt).toLocaleDateString("fa-IR")}</td>
                </tr>
              ))}
              {items.length === 0 && (
                <tr><td colSpan={10} style={{ textAlign: "center", color: "var(--text-secondary)" }}>موردی یافت نشد</td></tr>
              )}
            </tbody>
          </table>
        </div>
      )}

      <div className="flex-between mt-3">
        <span className="text-sm">مجموع: {total}</span>
        <div className="flex gap-2">
          <button className="btn btn-secondary btn-sm" disabled={page <= 1} onClick={() => setPage((p) => p - 1)}>قبلی</button>
          <span className="text-sm">صفحه {page}</span>
          <button className="btn btn-secondary btn-sm" disabled={page * pageSize >= total} onClick={() => setPage((p) => p + 1)}>بعدی</button>
        </div>
      </div>
    </div>
  );
}
